module.exports = __webpack_public_path__ + "static/img/references6.aefe802.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/references6.jpeg
// module id = rNxq
// module chunks = 1